import { Reveal } from "@/components/site/Reveal";

export const Acknowledgement = () => (
  <section data-testid="acknowledgement-section" className="bg-sand px-5 py-24 sm:px-10 lg:py-36">
    <div className="mx-auto grid max-w-[1440px] gap-10 lg:grid-cols-12">
      <Reveal className="lg:col-span-3">
        <p className="eyebrow text-ochre">Acknowledgement of Country</p>
        <div className="mt-6 h-px w-24 bg-ochre" />
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-9">
        <p className="font-display text-3xl font-medium leading-[1.2] text-ink sm:text-4xl sm:leading-[1.2] lg:text-[3.4rem] lg:leading-[1.18]">
          We acknowledge the <span className="italic text-gum">Gweagal people</span> of the Dharawal nation, Traditional
          Custodians of the lands and waters of Kamay, where we live, learn and work. We pay our respects to Elders past and
          present, and to all Aboriginal and Torres Strait Islander peoples.
        </p>
      </Reveal>
    </div>
  </section>
);
